<template>
  <div>
    <!-- Popup Modal -->
    <pl-dialog
      :title="'Course Sync'"
      :headerStyle="'text-align: center; font-weight:bold'"
      :disableOutsideClick="true"
      @close="closeModal"
      :size="'sm'"
    >
      <div class="my-3 px-7">
        {{ header }}
      </div>
      <!-- Model Content and Inputs -->
      <div class="course-modal-content flex-grow overflow-y-auto py-3 px-7">
        <div
          class="flex justify-center"
          style="max-height: calc(80vh - 220px); overflow-y: auto"
        >
          <ul>
            <li
              v-for="(course, index) in courses_I_teach"
              :key="course.id"
              @click="selectCourse(index)"
              class="flex flex-nowrap items-center w-100"
            >
              <div>
                <pl-checkbox
                  v-model="selectedCourses"
                  :value="course"
                  @change="selectedCourses()"
                  class=""
                />
              </div>
              <div>
                <label :for="course.title">
                  {{ course.title | truncate(26) }}
                  {{ course.sections[0] ? ' - ' : '' }}
                  {{ course.sections[0] | truncate(10) }}
                  <template v-if="course.is_archived">
                    <span class="ruby"> (Archived) </span>
                  </template>
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- Form Controls -->

      <div class="my-5 center items-center">
        <button
          class="px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold"
          @click="confirmSync"
        >
          Confirm Sync
        </button>
      </div>
    </pl-dialog>
  </div>
</template>

<script lang="babel">

  import { mapGetters } from 'vuex';
  import get from 'lodash/get';
  import { EventBus } from 'utils/event-bus';

  export default {
    data() {
      return {
        form_data: {
          title: '',
          section: '',
        },
        error_title: '',
        is_school_course: true,
        selectedCourses: [],
        selected_index:null,
      };
    },
    props:{
      header:{
        type:String,
        default:'',
        required:true
      },
      showUpgrade:{
        type:Boolean,
        default:false,
        required:true,
      },
      school:{
        type:Object,
        default:null,
      }
    },
     watch: {
      selectedCourses: function (selectedCourses) {
        return selectedCourses;
      },
      courses_I_teach(){
        this.selectedCourses = this.courses_I_teach.filter(c => !c.is_archived);
      }
    },
    computed: {
      ...mapGetters(['getProfile','getCurrentSchool','getCourses']),
      hasSchool(){
        return this.getProfile.school.school_id;
      },
      courses_I_teach() {
        return this.getCourses.filter((course) => {
          const role = get(course, 'users[0].subscription.role');
          return ['author'].includes(role);
        });
      },
    },
    mounted(){
      this.selectedCourses = this.courses_I_teach.filter(c => !c.is_archived);
    },
    methods: {
      selectCourse(index) {
        this.selected_index = index;
      },
      closeModal() {
        this.$emit('closeModal');
      },
      confirmSync(){
        const school_id = this.getProfile.school.school_id ? this.getProfile.school.school_id : this.school.id;
        let synced_school_courses = false;
        const payload = {
          courses_ids: this.selectedCourses.map(c => c.id),
          school_id
        };
        this.$store.dispatch('syncCourses',payload).then(() => {
          synced_school_courses = true;
          const name = this.getProfile.school.name ? this.getProfile.school.name : this.school.name;
          const payload = {
              synced_school_courses,
              school_id,
              name
          };
          this.$store.dispatch('updateUserSchool',payload);

        }).catch(() => {
          EventBus.$emit('toast-msg','Something went wrong while syncing the courses. Please try again.');
        }).
        finally(() =>{
            this.closeModal();
            if (this.showUpgrade){
              EventBus.$emit('upgradeSuccess');

            }
        });
      },
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~app/global-stylus.styl'

  .ruby
    color: pl-ruby

  .course-modal-content
    margin-top:15px;

  ::-webkit-scrollbar
      display: block;
      width: 10px
      -webkit-appearance: none;
</style>



// WEBPACK FOOTER //
// schoolCoursesModal.vue?3630f0bf